<script>
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import toggleModal from '@/mixins/toggleModal';
import UploadImages from '@/components/ux/upload/Upload-images.vue';

const b = bem('art-frame');
export default {
  components: { UploadImages },
  data() {
    return {
      isDefault: false,
      pmVisible: false,
      visible: false,
      usePlaceholder: false,
      files: [],
      defaultFiles: [],
      isPackage: false,
      isToggle: false,
      isLicense: false,
      customSizeEnabled: false,
      customSizeForm: {
        price_per_sq_inch: null,
        base_price: null,
        min_width: 4,
        max_width: 48,
        min_height: 4,
        max_height: 94,
        min_aspect_ratio: 0.25,
        max_aspect_ratio: 4.0,
        optimal_ppi: 220,
      },
    };
  },
  props: {
    frame: Object,
    isNew: Boolean,
    frameMaterialId: {
      type: Number,
      required: true,
    },
  },
  mixins: [toggleModal],
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      templateFrameAction: 'createTemplate/templateFrame',
      getCollagePreviewImagesAction: 'createTemplate/getCollagePreviewImages',
      postCollagePreviewImagesAction: 'createTemplate/postCollagePreviewImages',
      deleteCollagePreviewImageAction: 'createTemplate/deleteCollagePreviewImage',
      getCustomSizeSettingsAction: 'createTemplate/getProductCustomSizeSettings',
      saveCustomSizeSettingsAction: 'createTemplate/saveProductCustomSizeSettings',
      deleteCustomSizeSettingsAction: 'createTemplate/deleteProductCustomSizeSettings',
    }),
    handleOk(values) {
      const frame = {
        displayName: values.displayName,
        isDefault: this.isDefault,
        visible: this.visible,
        price: 0,
        url: values.url,
        seoTitle: values.seoTitle,
        seoDescription: values.seoDescription,
        // customInfo: JSON.stringify({
        //   sizeTitle: values.sizeTitle || '',
        //   colorTitle: values.colorTitle || '',
        //   orientationTitle: values.orientationTitle || '',
        //   displaysTitle: values.displaysTitle || '',
        //   isDisplaysTitle: values.isDisplaysTitle || false,
        //   minForArrows: values.minForArrows || 3,
        // }),
      };
      if (this.isNew) {
        frame.frameMaterialId = this.frameMaterialId;
      }
      if (!this.isNew) {
        frame.pmVisible = this.pmVisible;
        frame.usePlaceholder = this.usePlaceholder;
        frame.isToggle = this.isToggle;
        frame.isPackage = this.isPackage;
        frame.isLicense = this.isLicense;
      }
      const file = this.defaultFiles[0]?.file || null;
      this.templateFrameAction({
        frame,
        file,
        type: this.isNew ? 'POST' : 'PUT',
        id: this.frame.id,
        name: values.name,
      });

      const images = this.files.map(({ file: fl }) => fl || null)
        .filter((item) => item);
      if (images?.length) {
        this.postCollagePreviewImagesAction({
          images,
          imageNames: images.map((itm) => itm.name),
          productId: this.frame.id,
        });
      }

      // Save custom size settings if enabled
      this.saveCustomSize();

      this.hideModal();
    },
    onRemove(file) {
      const currentImage = this.collagePreviewImage.find(({ imageUrl }) => imageUrl === file.url);
      this.deleteCollagePreviewImageAction({
        id: currentImage.id,
        productId: this.frame.id,
      });
      return false;
    },
    getInitialImages() {
      return this.collagePreviewImage?.length
        ? this.collagePreviewImage.map(({ imageUrl }) => (imageUrl))
        : [];
    },
    getDefaultInitialImages() {
      return this.frame.imageUri ? [this.frame.imageUri] : [];
    },
    deleteCustomSizeSettings() {
      if (this.customSizeSettings?.id) {
        this.deleteCustomSizeSettingsAction({
          id: this.customSizeSettings.id,
          productId: this.frame.id,
        });
      }
      this.customSizeEnabled = false;
    },
    saveCustomSize() {
      if (this.customSizeEnabled && !this.isNew) {
        this.saveCustomSizeSettingsAction({
          productId: this.frame.id,
          settings: {
            id: this.customSizeSettings?.id,
            price_per_sq_inch: this.customSizeForm.price_per_sq_inch,
            base_price: this.customSizeForm.base_price,
            min_width: this.customSizeForm.min_width || 4,
            max_width: this.customSizeForm.max_width || 48,
            min_height: this.customSizeForm.min_height || 4,
            max_height: this.customSizeForm.max_height || 94,
            min_aspect_ratio: this.customSizeForm.min_aspect_ratio || 0.25,
            max_aspect_ratio: this.customSizeForm.max_aspect_ratio || 4.0,
            optimal_ppi: this.customSizeForm.optimal_ppi || 220,
          },
          isNew: !this.customSizeSettings?.id,
        });
      }
    },
  },
  mounted() {
    if (!this.isNew) {
      this.getCollagePreviewImagesAction(this.frame.id);
      this.getCustomSizeSettingsAction(this.frame.id);
      this.isDefault = this.frame.isDefault;
      this.pmVisible = this.frame.pmVisible;
      this.visible = this.frame.visible;
      this.usePlaceholder = this.frame.usePlaceholder;
      this.otherDesign = this.frame.otherDesign;
      this.defaultFiles = this.frame.imageUri ? [{
        file: null,
        url: this.frame.imageUri,
      }] : [];
      this.isPackage = this.frame.isPackage;
      this.isLicense = this.frame.isLicense;
      this.isToggle = this.frame.isToggle;
    }
  },
  computed: {
    ...mapState({
      collagePreviewImage: (state) => state.createTemplate.collagePreviewImage,
      isLoadImages: (state) => state.createTemplate.isLoadImages,
      customSizeSettings: (state) => state.createTemplate.customSizeSettings,
    }),
  },
  watch: {
    collagePreviewImage: {
      handler(newValue) {
        this.files = newValue.map(({ imageUrl }) => ({ imageUrl, file: null }));
      },
      deep: true,
    },
    customSizeSettings: {
      handler(newValue) {
        this.customSizeEnabled = !!newValue;
        if (newValue) {
          this.customSizeForm = {
            price_per_sq_inch: newValue.price_per_sq_inch,
            base_price: newValue.base_price,
            min_width: newValue.min_width || 4,
            max_width: newValue.max_width || 48,
            min_height: newValue.min_height || 4,
            max_height: newValue.max_height || 94,
            min_aspect_ratio: newValue.min_aspect_ratio || 0.25,
            max_aspect_ratio: newValue.max_aspect_ratio || 4.0,
            optimal_ppi: newValue.optimal_ppi || 220,
          };
        }
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" width="fit-content" @cancel="hideModal">
    <div :class="b('')">
      <FormKit
        type="form"
        :submit-label="isNew ? 'Create' : 'Save'"
        @submit="handleOk"
      >
        <h1>{{ isNew ? 'New frame' : `Edit ${frame.displayName}` }}</h1>
        <div :class="b('content', { collage: frame?.name === 'collage' })">
          <div :class="b('left-side')">
            <div :class="b('input')">
              <FormKit
                  type="select"
                  name="name"
                  label="Type"
                  placeholder="Please select type"
                  :value="frame.name"
                  :options="[
                      { value: 'photo_art', label: 'Frame'},
                      { value: 'collage', label: 'Collage' }
                  ]"
                  validation="required"
              />
            </div>
            <div :class="b('input')">
              <FormKit
                  type="text"
                  name="displayName"
                  label="Display name"
                  validation="required"
                  placeholder="Type frame name"
                  :value="frame.displayName"
              />
            </div>
            <div :class="b('input')">
              <FormKit
                  type="text"
                  name="url"
                  label="Product url"
                  validation="required"
                  placeholder="Type product url"
                  :value="frame.url"
              />
            </div>
            <div :class="b('input')">
              <FormKit
                  type="text"
                  name="seoTitle"
                  label="Product seo title"
                  validation="required"
                  placeholder="Type product seo title"
                  :value="frame.seoTitle"
              />
            </div>
            <div :class="b('input')">
              <FormKit
                  type="text"
                  name="seoDescription"
                  label="Product seo description"
                  validation="required"
                  placeholder="Type product seo description"
                  :value="frame.seoDescription"
              />
            </div>
            <div :class="b('input', { row: true })">
              <div :class="b('input-wrap')">
                <span :class="b('input-title')">Default frame</span>
                <a-switch
                    checked-children="Yes"
                    un-checked-children="No"
                    v-model:checked="isDefault"
                />
              </div>
              <div :class="b('input-wrap')" v-if="!isNew">
                <span :class="b('input-title')">Use placeholder</span>
                <a-switch
                    checked-children="Yes"
                    un-checked-children="No"
                    v-model:checked="usePlaceholder"
                />
              </div>
            </div>
            <div :class="b('input', { row: true })">
              <div :class="b('input-wrap')" v-if="!isNew">
                <span :class="b('input-title')">Visible on pm</span>
                <a-switch
                    checked-children="Yes"
                    un-checked-children="No"
                    v-model:checked="pmVisible"
                />
              </div>
              <div :class="b('input-wrap')">
                <span :class="b('input-title')">Visible on site</span>
                <a-switch
                    checked-children="Yes"
                    un-checked-children="No"
                    v-model:checked="visible"
                />
              </div>
            </div>
            <div :class="b('input', { row: true })" v-if="!isNew">
              <div :class="b('input-wrap')">
                <span :class="b('input-title')">Hide rotate toggle?</span>
                <a-switch
                    checked-children="Yes"
                    un-checked-children="No"
                    v-model:checked="isToggle"
                />
              </div>
              <div :class="b('input-wrap')">
                <span :class="b('input-title')">Signage ?</span>
                <a-switch
                    checked-children="Yes"
                    un-checked-children="No"
                    v-model:checked="isPackage"
                />
              </div>
            </div>
            <div :class="b('input-wrap')">
              <span :class="b('input-title')">License ?</span>
              <a-switch
                  checked-children="Yes"
                  un-checked-children="No"
                  v-model:checked="isLicense"
              />
            </div>
          </div>
          <div :class="b('right-side')">
            <span :class="b('input-title')">Default image</span>
            <UploadImages
              v-if="!isLoadImages"
              :is-multiple="false"
              v-model:files="defaultFiles"
              :initial-images="getDefaultInitialImages()"
            />
          </div>
          <div :class="b('right-side')">
            <div :class="b('input-title')">First image - photo art</div>
            <div :class="b('input-title')">Second image - enhance</div>
            <UploadImages
              v-if="!isLoadImages"
              is-multiple
              v-model:files="files"
              :initial-images="getInitialImages()"
              :onRemove="onRemove"
              :max-number="frame?.name !== 'collage' ? 2 : 10"
            />
          </div>
        </div>
        <div :class="b('wizard-settings')">
          <h2>Wizard settings</h2>
          <div :class="b('input-line-wrap')">
            <div :class="b('input')">
              <FormKit
                  type="text"
                  name="sizeTitle"
                  label="Size title"
                  placeholder="Type size title"
                  :value="frame.customInfo?.sizeTitle"
              />
            </div>
            <div :class="b('input')">
              <FormKit
                  type="text"
                  name="colorTitle"
                  label="Color title"
                  placeholder="Type color title"
                  :value="frame.customInfo?.ColorTitle"
              />
            </div>
          </div>
          <div :class="b('input-line-wrap')">
            <div :class="b('input')">
              <FormKit
                  type="select"
                  name="name"
                  label="Type"
                  placeholder="Please select type"
                  :value="frame.customInfo?.isDisplaysTitle"
                  :options="[
                      { value: 'true', label: 'Seprate Displays'},
                      { value: 'false', label: 'Not seprate Displays' }
                  ]"
              />
            </div>
            <div :class="b('input')">
              <FormKit
                  type="text"
                  name="displaysTitle"
                  label="Displays title"
                  placeholder="Type displays title"
                  :value="frame.customInfo?.displaysTitle"
              />
            </div>
          </div>
          <div :class="b('input-line-wrap')">
            <div :class="b('input')">
              <FormKit
                  type="text"
                  name="orientationTitle"
                  label="Orientation title"
                  placeholder="Type orientation title"
                  :value="frame.customInfo?.orientationTitle"
              />
            </div>
            <div :class="b('input')">
              <FormKit
                  type="number"
                  name="minForArrows"
                  label="Min quantity for arrows"
                  placeholder="Type min quantity for arrows"
                  :value="frame.customInfo?.minForArrows"
              />
            </div>
          </div>
        </div>
        <!-- Custom Size Settings Section -->
        <div :class="b('custom-size-settings')" v-if="!isNew">
          <h2>Custom Size Settings</h2>
          <div :class="b('input-wrap')">
            <span :class="b('input-title')">Enable Custom Size</span>
            <a-switch
              v-model:checked="customSizeEnabled"
              checked-children="Yes"
              un-checked-children="No"
            />
          </div>

          <template v-if="customSizeEnabled">
            <div :class="b('input-line-wrap')">
              <div :class="b('input')">
                <FormKit
                  type="number"
                  name="pricePerSqInch"
                  label="Price per sq inch ($)"
                  placeholder="0.15"
                  step="0.0001"
                  v-model="customSizeForm.price_per_sq_inch"
                />
              </div>
              <div :class="b('input')">
                <FormKit
                  type="number"
                  name="basePrice"
                  label="Base price ($)"
                  placeholder="29.99"
                  step="0.01"
                  v-model="customSizeForm.base_price"
                />
              </div>
            </div>

            <div :class="b('input-line-wrap')">
              <div :class="b('input')">
                <FormKit
                  type="number"
                  name="minWidth"
                  label="Min width (inches)"
                  v-model="customSizeForm.min_width"
                />
              </div>
              <div :class="b('input')">
                <FormKit
                  type="number"
                  name="maxWidth"
                  label="Max width (inches)"
                  v-model="customSizeForm.max_width"
                />
              </div>
            </div>

            <div :class="b('input-line-wrap')">
              <div :class="b('input')">
                <FormKit
                  type="number"
                  name="minHeight"
                  label="Min height (inches)"
                  v-model="customSizeForm.min_height"
                />
              </div>
              <div :class="b('input')">
                <FormKit
                  type="number"
                  name="maxHeight"
                  label="Max height (inches)"
                  v-model="customSizeForm.max_height"
                />
              </div>
            </div>

            <div :class="b('input-line-wrap')">
              <div :class="b('input')">
                <FormKit
                  type="number"
                  name="minAspectRatio"
                  label="Min aspect ratio"
                  step="0.01"
                  v-model="customSizeForm.min_aspect_ratio"
                />
              </div>
              <div :class="b('input')">
                <FormKit
                  type="number"
                  name="maxAspectRatio"
                  label="Max aspect ratio"
                  step="0.01"
                  v-model="customSizeForm.max_aspect_ratio"
                />
              </div>
            </div>

            <div :class="b('input-line-wrap')">
              <div :class="b('input')">
                <FormKit
                  type="number"
                  name="optimalPpi"
                  label="Optimal PPI"
                  v-model="customSizeForm.optimal_ppi"
                />
              </div>
            </div>

            <a-button
              v-if="customSizeSettings?.id"
              type="primary"
              danger
              @click="deleteCustomSizeSettings"
              style="margin-top: 16px;"
            >
              Delete Custom Size Settings
            </a-button>
          </template>
        </div>
      </FormKit>
    </div>
  </a-modal>
</template>

<style lang="scss">
@import "@/styles/variables";

.art-frame {
  &__content {
    display: flex;
    justify-content: space-between;

    height: fit-content;
    max-height: 600px;
  }

  &__input {
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    &_row {
      flex-direction: row;
      margin-bottom: 20px;
    }
  }

  &__input-wrap {
    margin-right: 20px;
  }

  &__input-title {
    margin-right: 10px;
  }

  &__button {
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  &__right-side {
    margin-top: 18px;
    overflow-y: auto;
    max-height: 350px;

    .ant-upload-list-picture-card,
    .ant-upload-list-picture-select-card,
    .ant-upload-select,
    .ant-upload,
    .ant-upload-list-item-container {
      width: 200px !important;
      height: 200px !important;
    }
  }
  &__input-line-wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  &__custom-size-settings {
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #e8e8e8;

    h2 {
      margin-bottom: 16px;
    }
  }
}
.formkit-outer {
  width: 100%;
}
</style>
